module.exports = __webpack_public_path__ + "static/icons_startseite_einkauf-0f55aec75dd9d8a8166ccad7c203cba9.png";